import { RESEARCH_IMAGES } from "@/lib/utils";

const ResearchInnovationImageGrid = () => {
  return (
    <div className="relative w-full max-w-[800px] mx-auto">
      {RESEARCH_IMAGES.map((img, index) => (
        <img
          key={index}
          src={img.src}
          alt={img.alt}
          className={img.className}
          style={img.style}
        />
      ))}
    </div>
  );
};

export default ResearchInnovationImageGrid;
